<template>
  <v-container
    v-if="visible || page !== true"
    class="pt-0 fill-height"
    :class="{ 'h-screen': page }"
  >
    <v-row no-gutters justify="center" align="center">
      <v-col cols="auto" class="ml-11">
        <v-progress-circular :size="120" color="loadingRed" indeterminate />
        <v-icon :size="44" class="relative-to-progress" color="szRed"> $paczkopedia </v-icon>
      </v-col>
      <v-col
        v-if="page"
        cols="12"
        class="sz-primary-grey--text f-18 font-weight-regular text-center mt-3"
        style="color: #414345"
      >
        <p class="mb-0">
          {{ $t('general.loader.title') }}
        </p>
        <p class="mb-0">
          {{ $t('general.loader.subtitle') }}
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'LoaderComponent',
  props: {
    page: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      timeout: 1000,
      visible: false
    }
  },
  created() {
    setTimeout(() => {
      this.visible = true
    }, this.timeout)
  }
}
</script>

<style lang="scss" scoped>
.relative-to-progress {
  position: relative;
  transform: translate(-50%, 0);
  left: -60px;
}
</style>
